import { defineStore } from "pinia";

export const useFormBlockerStore = defineStore("formBlocker", {
  state: () => ({
    blockersByFormId: {},
  }),

  getters: {
    formIsBlocked: (state) => (formId) => {
      if (!formId) return false;

      return Object.values(state.blockersByFormId[formId] || {}).some(
        (blocker) => blocker.blocked
      );
    },
    formBlockMessage: (state) => (formId) => {
      if (!formId) return "";

      const blocker = Object.values(
        state.blockersByFormId[formId] || {}
      ).find((item) => item.blocked && item.message);

      return blocker?.message || "";
    },
    formBlockIsLoading: (state) => (formId) => {
      if (!formId) return false;

      return Object.values(state.blockersByFormId[formId] || {}).some(
        (blocker) => blocker.blocked && blocker.loading
      );
    },
  },

  actions: {
    setFormBlocker(
      formId,
      blockerId,
      blocked,
      message = "",
      loading = false
    ) {
      if (!formId || !blockerId) return;

      this.blockersByFormId = {
        ...this.blockersByFormId,
        [formId]: {
          ...(this.blockersByFormId[formId] || {}),
          [blockerId]: {
            blocked: Boolean(blocked),
            message,
            loading: Boolean(loading),
          },
        },
      };
    },

    clearFormBlocker(formId, blockerId) {
      if (!formId || !blockerId) return;

      const blockers = { ...(this.blockersByFormId[formId] || {}) };
      delete blockers[blockerId];

      this.blockersByFormId = {
        ...this.blockersByFormId,
        [formId]: blockers,
      };
    },
  },
});
